export default __webpack_public_path__ + "static/media/exit.42de8f10.svg";